import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import moment from "moment/moment";
import { ShowToast } from "../../../../helpers/ToastService";
import {
  AddPatientSign,
  GetPatientSign,
  GetconsentManagement,
  UpdatePatientSign,
} from "../../../../api/helper";
import axios from "axios";

const PatinetConsents = ({ info }) => {
  const [consentdata, setconsentdata] = useState([]);
  const [ismodal, setIsModal] = useState(false);
  const [selectedConsent, setSelectedConsent] = useState(null);
  const [signedBy, setSignedBy] = useState("");
  const [checkingbox, setCheckingbox] = useState(false);
  const [signdata, setsigndata] = useState([]);
  const [signmodal, setsignmodal] = useState(false);
  const [selectedTitle, setselectedTitle] = useState("");
  const { isLoading } = useSelector((store) => store.sliceReducer);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);

  const openModal = (item) => {
    console.log(item?._id);
    getSigned(item?._id);
    setSelectedConsent(item);
    setIsModal(true);
  };

  const closeModal = () => {
    setCheckingbox(false);
    setSignedBy("");
    setsigndata([]);
    setIsModal(false);
    setSelectedConsent(null);
  };
  const FetchConsentManagement = async () => {
    try {
      const respo = await GetconsentManagement(info?.agencyIds[0]?._id);
      setconsentdata(respo?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (info?.agencyIds?.[0]?._id) {
      FetchConsentManagement();
    }
  }, [info?.agencyIds]);

  const dob = new Date(info?.DOB);
  const day = String(dob.getDate()).padStart(2, "0");
  const month = String(dob.getMonth() + 1).padStart(2, "0");
  const year = dob.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;

  const openSignModal = (item) => {
    const hasMatchingConsent = item?.informedConsent.find(
      (consent) =>
        consent.agencyId === info?.agencyIds[0]?._id &&
        consent.patientId === profiledata?._id
    );

    setSelectedConsent(hasMatchingConsent);
    setselectedTitle(item);
    setsignmodal(true);
  };
  const closeSIgnModal = () => {
    setsignmodal(false);
    setCheckingbox(false);
    setSignedBy("");
    setsigndata([]);
    setselectedTitle("");
    setSelectedConsent(null);
  };
  const AddSignofpatient = async () => {
    if (!checkingbox) {
      ShowToast("Please check the consent box before signing.");
      return;
    }
    if (signedBy === "") {
      ShowToast("Please Add Sign");
      return;
    }
    let ipAddress = "";
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const ipResponse = await axios.get("https://api.ipify.org?format=json");
      ipAddress = ipResponse.data.ip;
    } catch (error) {
      console.log("Error fetching IP address:", error);
      ipAddress = "unknown";
    }

    const data = {
      consentManagementId: selectedConsent?.consentManagementId,
      agencyId: info?.agencyIds[0]?._id,
      patientId: profiledata?._id,
      signedDate: new Date().toISOString(),
      Signedby: signedBy,
      checkingbox: true,
      ipAddress: ipAddress,
      timeZone: timeZone,
    };
    try {
      const respo = await UpdatePatientSign(data, selectedConsent?._id);
      ShowToast(respo?.data?.message);
      closeSIgnModal();
      FetchConsentManagement();
    } catch (error) {
      console.log(error);
    }
  };
  const getSigned = async (id) => {
    try {
      const respo = await GetPatientSign(profiledata?._id, id);
      setsigndata(respo?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="container_NotesTabScreen">
        <h1>PatinetConsents</h1>
        <table>
          <thead>
            <tr>
              <th>Consent Title</th>
              <th>Status</th>
              <th>Sign Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {consentdata.filter((item) => item.status !== "Inactive").length ===
            0 ? (
              <tr>
                <td colSpan="10">No active consent found</td>
              </tr>
            ) : (
              consentdata
                .filter((item) => item.status !== "Inactive")
                .map((item, index) => {
                  const hasMatchingConsent = item?.informedConsent?.find(
                    (consent) =>
                      consent.agencyId === info?.agencyIds[0]?._id &&
                      consent.patientId === profiledata?._id
                  );
                  return (
                    <tr key={item._id || index}>
                      <td>{item.Title}</td>
                      <td
                        className={
                          item.status === "active"
                            ? "status-signed"
                            : "status-sent"
                        }
                      >
                        {item.status}
                      </td>
                      <td>
                        {hasMatchingConsent ? (
                          hasMatchingConsent.Signedby ? (
                            <span style={{}}>Signed</span>
                          ) : (
                            <span style={{}}>Not Signed</span>
                          )
                        ) : (
                          <span style={{}}>Not Signed</span>
                        )}
                      </td>
                      <td>
                        <button
                          style={{
                            width: 100,
                          }}
                          className="view-btn"
                          onClick={() => openModal(item)}
                        >
                          View
                        </button>
                        {item.status === "active" && (
                          <button
                            className="download-btn"
                            style={{ marginLeft: 10 }}
                          >
                            Download PDF
                          </button>
                        )}
                        {hasMatchingConsent && !hasMatchingConsent.Signedby && (
                          <button
                            style={{ marginLeft: 10, backgroundColor: "green" }}
                            className="save-button_Vitals"
                            onClick={() => {
                              openSignModal(item);
                            }}
                          >
                            View Signature Request
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
            )}
          </tbody>
        </table>
        {ismodal && selectedConsent && (
          <div className="modal_Consent">
            {isLoading && (
              <div className="modal_Consent_loader">
                <div className="spinner"></div>
              </div>
            )}

            <div
              style={{
                fontSize: "20px",
                cursor: "pointer",
                width: 50,
                position: "absolute",
                right: 1,
                top: 2,
              }}
            >
              <span className="close" onClick={closeModal}>
                &times;
              </span>
            </div>
            <div
              style={{
                alignItems: "flex-start",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <h1>Informed Consent for Treatment</h1>
              <p>
                <strong>Category:</strong> {selectedConsent.Title}
              </p>
              <p>
                <strong>Consent Type:</strong> {selectedConsent.Category}
              </p>
              <p>
                <strong>Client Name:</strong>{" "}
                {info?.firstName + " " + info?.lastName}
              </p>
              <p>
                <strong>Agency Name:</strong>{" "}
                {selectedConsent.agency?.firstName +
                  " " +
                  selectedConsent.agency?.lastName}
              </p>
              <p style={{ textAlign: "left" }}>
                <strong>Consent Details:</strong>{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: selectedConsent.Content }}
                />
              </p>

              <div className="signature-section">
                <h2 style={{ textAlign: "left" }}>Signature :</h2>

                <p style={{ textAlign: "left" }}>
                  {signdata.length > 0 && signdata[0].Signedby ? (
                    <>
                      <strong>Signed by:</strong>
                      <span>{signdata[0].Signedby}</span>
                    </>
                  ) : null}
                </p>

                {signdata.length > 0 && signdata[0].Signedby ? (
                  <p style={{ textAlign: "left" }}>
                    <strong>Date and Time:</strong>{" "}
                    <span>
                      {signdata[0].signedDate
                        ? moment(signdata[0].signedDate).format(
                            "DD-MM-YYYY / hh:mm A"
                          )
                        : "Date not available"}
                    </span>
                  </p>
                ) : null}

                <p style={{ textAlign: "left" }}>
                  <strong>Patient Name:</strong>{" "}
                  {profiledata?.firstName + " " + profiledata?.lastName}
                </p>
                <p style={{ textAlign: "left" }}>
                  <strong>Patient DOB:</strong> {formattedDate}
                </p>
                <p style={{ textAlign: "left" }}>
                  {signdata.length > 0 && signdata[0].Signedby ? (
                    <>
                      <strong>IP Address :</strong>

                      <span>{signdata[0].ipAddress}</span>
                    </>
                  ) : null}
                </p>
                <p style={{ textAlign: "left" }}>
                  {signdata.length > 0 && signdata[0].Signedby ? (
                    <>
                      <strong>TimeZone :</strong>

                      <span>{signdata[0].timeZone}</span>
                    </>
                  ) : null}
                </p>
              </div>
              <button className="button_Consent" onclick="window.print()">
                Print Consent
              </button>
            </div>
          </div>
        )}
      </div>
      {signmodal && (
        <div className="modal_Consent">
          <div className="modal-content__two">
            <button className="close_consent_modal" onClick={closeSIgnModal}>
              ×
            </button>
            <h3 style={{ textAlign: "left" }}>{selectedTitle?.Title}</h3>
            <p style={{ textAlign: "left" }}>
              <strong>Agency Name:</strong> {info?.agencyIds[0]?.companyName}
            </p>
            <p style={{ textAlign: "left" }}>
              <strong>Patient Name:</strong>{" "}
              {profiledata?.firstName + " " + profiledata?.lastName}
            </p>
            <p style={{ textAlign: "left" }}>
              <strong>Provider Name:</strong>{" "}
              {info?.agencyIds[0]?.firstName +
                " " +
                info?.agencyIds[0]?.lastName}
            </p>
            <hr />

            <div className="consent-checkbox">
              <label>
                <input
                  type="checkbox"
                  style={{ marginRight: 10 }}
                  checked={checkingbox}
                  onChange={() => setCheckingbox(!checkingbox)}
                />
                By checking this box, I agree to use electronic records and
                signatures and I acknowledge that I have read the related
                consumer disclosure.
              </label>
            </div>
            <div className="signature-block">
              <label className="signature-label" htmlFor="sig-officePolicies">
                Signature
              </label>
              <input
                type="text"
                value={signedBy}
                onChange={(e) => setSignedBy(e.target.value)}
                placeholder="Type your full name to sign..."
              />
              <button
                className="sign-btn"
                onClick={() => {
                  AddSignofpatient();
                }}
              >
                Sign Consent
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PatinetConsents;
